import type { IOTFCutOffTable } from "../../types/iotf.types";

export const iotfCutOffsV1: IOTFCutOffTable = {
  id: "iotf-cutoffs-v1",
  version: "1.0",
  status: "active",
  source: "Cole TJ et al. BMJ 2000;320:1240–1243. AHT Liraglutide PGD Appendix A. Verified June 2026.",
  validFrom: "2026-06-15",
  cutOffs: [
    { ageMonths: 144, sex: "male",   bmiCutOff: 26.02 },
    { ageMonths: 144, sex: "female", bmiCutOff: 26.67 },
    { ageMonths: 150, sex: "male",   bmiCutOff: 26.43 },
    { ageMonths: 150, sex: "female", bmiCutOff: 27.24 },
    { ageMonths: 156, sex: "male",   bmiCutOff: 26.84 },
    { ageMonths: 156, sex: "female", bmiCutOff: 27.76 },
    { ageMonths: 162, sex: "male",   bmiCutOff: 27.25 },
    { ageMonths: 162, sex: "female", bmiCutOff: 28.20 },
    { ageMonths: 168, sex: "male",   bmiCutOff: 27.63 },
    { ageMonths: 168, sex: "female", bmiCutOff: 28.57 },
    { ageMonths: 174, sex: "male",   bmiCutOff: 27.98 },
    { ageMonths: 174, sex: "female", bmiCutOff: 28.87 },
    { ageMonths: 180, sex: "male",   bmiCutOff: 28.30 },
    { ageMonths: 180, sex: "female", bmiCutOff: 29.11 },
    { ageMonths: 186, sex: "male",   bmiCutOff: 28.60 },
    { ageMonths: 186, sex: "female", bmiCutOff: 29.29 },
    { ageMonths: 192, sex: "male",   bmiCutOff: 28.88 },
    { ageMonths: 192, sex: "female", bmiCutOff: 29.43 },
    { ageMonths: 198, sex: "male",   bmiCutOff: 29.14 },
    { ageMonths: 198, sex: "female", bmiCutOff: 29.56 },
    { ageMonths: 204, sex: "male",   bmiCutOff: 29.41 },
    { ageMonths: 204, sex: "female", bmiCutOff: 29.69 },
    { ageMonths: 210, sex: "male",   bmiCutOff: 29.70 },
    { ageMonths: 210, sex: "female", bmiCutOff: 29.84 },
    { ageMonths: 216, sex: "male",   bmiCutOff: 30.00 },
    { ageMonths: 216, sex: "female", bmiCutOff: 30.00 },
  ],
};
